module.exports = __webpack_public_path__ + "img/image-1.d69fa681.png";